import matter from 'gray-matter'
import { getHeroContent, parseTabData, sortByDate, usePagination } from '../../src/utils/helpers'
import {
  // Card, CardContent, Stack, Divider, tabsClasses, Tab, Tabs,
  Box, Container, Typography, Chip, Grid,
  Pagination, Breadcrumbs, AppBar, Link, Button,
} from '@mui/material';
// import TopPost from '../src/components/BlogPost/TopBlogs'
// import getBlogs from '../../lib/blogs/_getBlogs'
import { useState } from 'react'
import { styled } from '@mui/material/styles';
// import SearchBlog from '../../src/components/_common/SearchBlog';
import { dataConstants } from '../../src/constants';
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
// import { getRandomStr } from '../../src/helpers';
import getPageMetaTags from '../../lib/meta/_getMetaTags';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Idea from '../../src/components/StockIdea';
import getStockIdeas from '../../lib/stock-ideas/_getStockIdeas';
import TopIdea from '../../src/components/StockIdea/TopIdeas';
import PricingAdBanner from '../../src/components/PricingAdBanner';
import getStockTabs from '../../lib/stock/_getStockTabsData';
import { Masonry } from '@mui/lab';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  return {
    height: '24px',
    backgroundColor: 'transparent',
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      // backgroundColor: theme.palette.background.primary_light,
      // boxShadow: theme.shadows[1],
      icon: {
        color: theme.palette.background.primary,
      }
    },
    '&:active': {
      boxShadow: theme.shadows[1],
    },
  };
});

// const StyledTabs = styled((props) => (
//   <Tabs
//     {...props}
//     TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
//   />
// ))({
//   minHeight: '25px',
//   '& .MuiTabs-indicator': {
//     display: 'flex',
//     justifyContent: 'center',
//     backgroundColor: 'transparent',
//   },
//   '& .MuiTabs-indicatorSpan': {
//     maxWidth: 40,
//     width: '100%',
//     // backgroundColor: '#635ee7',
//   },
// });

// const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
//   ({ theme }) => ({
//     textTransform: 'capitalize',
//     fontWeight: theme.typography.fontWeightRegular,
//     fontSize: theme.typography.pxToRem(15),
//     marginRight: theme.spacing(1),
//     color: 'rgba(2, 11, 74, 0.7)',
//     minHeight: '25px',
//     minWidth: '55px',
//     padding: '3px 16px',
//     borderRadius: '5px',
//     backgroundColor: '#E7EBF0',
//     border: "1px solid",
//     borderColor: '#DAE2ED',
//     '&.Mui-selected': {
//       color: '#fff',
//       backgroundColor: '#2a2d64',
//       border: '1px solid rgba(255, 255, 255, 0.15)',
//     },
//     '&.Mui-focusVisible': {
//       backgroundColor: 'rgba(100, 95, 228, 0.32)',
//     },
//   }),
// );

// const ListItem = styled('li')(({ theme }) => ({
//   margin: theme.spacing(0.5),
// }));

// const handleTags = (e) => {
//   let arr = []
//   e?.map(d => d?.frontmatter?.tags && arr.push(...d?.frontmatter?.tags))
//   return arr
// }

export default function StockIdeasHome({ posts, themeMode, pageLoading, hero }) {
  // const [chipData, setChipData] = useState([
  //   { key: 0, label: 'January' },
  //   { key: 1, label: 'Earnings' },
  //   { key: 2, label: 'Yield Curve' },
  //   { key: 3, label: 'Undervalued' },
  //   { key: 4, label: 'Retail Sale' },
  //   { key: 5, label: '5 min read' },
  //   { key: 6, label: '2 min read' },
  // ]);

  // const [posts, setPosts] = useState(blogs);
  // const [showSearch, setShowSearch] = useState(false);
  // const [filter, setFilter] = useState(false);
  // const [filteredTag, setFilteredTag] = useState(null);
  // const [filterTags, setFilterTags] = useState(handleTags(blogs)?.filter((v, i, a) => a.indexOf(v) === i));
  const [page, setPage] = useState(1);
  // const [value, setValue] = useState(0);
  const ROWS_PER_PAGE = 7;

  // const handleFilterChange = (event, newValue) => {
  //   setValue(newValue);
  //   if (newValue <= 0) {
  //     handleDelete()
  //   } else {
  //     filterByTag(event?.target?.textContent)
  //   }
  // };

  // const count = Math.ceil(posts.slice(filter ? 0 : dataConstants.TOP_TWO_BLOGS).length / ROWS_PER_PAGE);
  // const _POSTS = usePagination(posts.slice(filter ? 0 : dataConstants.TOP_TWO_BLOGS), ROWS_PER_PAGE);
  const count = Math.ceil(posts.length / ROWS_PER_PAGE);
  const _POSTS = usePagination(posts, ROWS_PER_PAGE);

  const handlePaginationChange = (e, p) => {
    let elmntToView = document.getElementById("all-ideas");
    elmntToView.scrollIntoView();
    setPage(p);
    _POSTS.jump(p);
  };

  // const filterByTag = (filter) => {
  //   let elmntToView = document.getElementById("all-ideas");
  //   elmntToView.scrollIntoView();

  //   // setPosts(blogs.filter(d => filters.every(filter => d.slug.includes(filter))))
  //   setPosts(blogs.filter(d => d?.frontmatter?.tags && d?.frontmatter?.tags.find(d => d === filter)))
  //   setFilter(true)
  //   _POSTS.jump(1);
  //   setPage(1);
  //   setFilteredTag(`tagged as <span class="filtered-tag">"${filter}"<span>`)
  // }

  // const handleDelete = () => {
  //   setPosts(blogs)
  //   setFilter(false)
  //   setFilteredTag(null)
  // };

  return (
    <>
      {/* <Box
        sx={{ background: '#f8f9fa', boxShadow: 'inset 0px -8px 24px rgba(214, 227, 255, 0.26)' }}>
        <Container maxWidth="md" className='card card-page' sx={{ pt: 5, pb: 1 }}>
          <Box component="div" sx={{ my: 2 }}>
            <Typography variant="h1" className='post-title' sx={{ fontWeight: 700, mt: 2, fontSize: '2rem' }}>
              {`Stock Ideas`}
            </Typography>
          </Box>
        </Container>
      </Box> */}
      <AppBar position="static" id="all-ideas"
        sx={{
          scrollMarginTop: "57px", zIndex: 999, top: '1.3rem',
          // p: 1, pb: 1.5, borderRadius: '5px',
          bgcolor: themeMode === 'dark' ? 'background.default' : '#f5f5f7',
          // boxShadow: 'inset 0px -8px 24px rgba(214, 227, 255, 0.26)'
        }} elevation={0}
      >
        <Container maxWidth="lg" sx={{ maxWidth: { md: '1030pxx', } }}>
          {/* <Box component="nav"
            className="bread-container"
            sx={{
              mt: 1, padding: '8px 8px 8px 0', borderRadius: '5px',
            }}>
            <Breadcrumbs>
              <Link prefetch={false} color="inherit" href={`${dataConstants.NAVS.HOME}`} >
                <StyledBreadcrumb
                  label="Home"
                  icon={<HomeRoundedIcon sx={{ '&.MuiChip-icon': { color: 'text.very_light_desc', fontSize: '1.1rem' }, color: 'text.link' }} fontSize="small" />}
                  sx={{ color: 'text.very_light_desc', fontSize: '.78rem', cursor: 'pointer', '& .MuiChip-label': { pr: 0, lineHeight: 1 }, '& .MuiChip-icon': { ml: 0 } }}
                />
              </Link>
              <StyledBreadcrumb
                label={`Stock Ideas`}
                className={'bread-bg-blue'}
                sx={{ color: 'text.very_light_desc', fontSize: '.78rem', '& .MuiChip-label': { p: 0, lineHeight: 1 } }}
              />
            </Breadcrumbs>
          </Box> */}
          <Box sx={{ display: 'flexx', alignItems: 'center', justifyContent: 'space-between', my: 7, textAlign: 'center' }}>
            <Typography color="#1d1d1f" variant="h1" sx={{ mx: 0, fontWeight: 600, fontSize: '1.6rem', lineHeight: '1', letterSpacing: '0.0075em', textTransform: 'capitalize' }}>
              {hero?.h1 ?? `Stock Ideas`}&nbsp;
              {/* <Typography variant="span"
                dangerouslySetInnerHTML={{ __html: filteredTag }}
              /> */}
            </Typography>
            <Typography variant='h1' component="p" sx={{ fontSize: '.97rem', color: '#333', my: 1 }}>{hero?.desc ?? `Explore expert-curated stock picks and investment ideas.`}</Typography>
          </Box>
        </Container>
      </AppBar>
      <Box component="div" sx={{ background: 'linear-gradient(180deg, #f5f5f7 90%, #fdfdfd)' }}>
        <Container maxWidth="xl" sx={{ maxWidth: { md: '1277px', } }}>
          {/*  <Divider id="all-ideas" sx={{ scrollMarginTop: "57px", mb: { md: 4, xs: 3 }, borderColor: 'transparent' }} />
          <Box component="div" sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' }, alignItems: { md: 'center', sm: 'start', xs: 'start' }, }}>
            <Typography variant="h6" sx={{ fontWeight: 600, '& .filtered-tag': { color: '#174c86', textTransform: 'capitalize' } }}>Ideas&nbsp;
              <Typography variant="span"
                dangerouslySetInnerHTML={{ __html: filteredTag }}
              />
            </Typography>
            <Box component="div" sx={{ bgcolor: 'primary.main', m: { xs: '0 auto', md: '0 0 0 auto' }, width: { md: '43ch', xs: '100%' }, borderRadius: '8px', mt: { xs: 4, md: 0 } }}>
              <SearchBlog setShowSearch={setShowSearch} posts={posts} placeholder="Search stock ideas..." />
            </Box>
          </Box> */}
          {/* {filterTags && filterTags.length > 0 ?
            <Box sx={{
              bgcolor: '#fff', position: 'sticky', top: '3rem', pt: 3, pb: 1.5, zIndex: 10,
              '& .MuiTabs-root .MuiTabs-scrollButtons': {
                position: 'absolute',
                py: .4,
                opacity: 1,
                zIndex: 99,
              },
              '& .MuiTabs-root .MuiTabs-scrollButtons.Mui-disabled': { display: 'none' },
              '& .MuiTabs-root .MuiTabScrollButton-root:first-child': {
                left: 0,
                background: 'linear-gradient(to right, rgb(255, 255, 255) 37%,rgba(33,33,33,0) 97%)',
                justifyContent: 'flex-start',
                width: '75px',
              },
              '& .MuiTabs-root .MuiTabScrollButton-root:last-child': {
                right: 0,
                background: 'linear-gradient(to left, rgb(255, 255, 255) 37%,rgba(33,33,33,0) 97%)',
                justifyContent: 'flex-end',
                width: '75px',
              }
            }}>
              <StyledTabs
                value={value}
                onChange={handleFilterChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                aria-label="scrollable blog filters"
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    '&.Mui-disabled': { opacity: 0.3 },
                  },
                }}
              >
                <StyledTab label="All" />
                {filterTags && filterTags?.map((d) => {
                  return (<StyledTab label={d} />);
                })}
              </StyledTabs>
            </Box> : null} */}
          <Box sx={{}}>
            <Grid container spacing={4}
            // direction={{ sm: "row-reverse" }}
            >
              {/* <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                <PricingAdBanner />
              </Grid> */}
              {_POSTS?.currentData()?.map((post, index) => (
                index <= 0 && page <= 1
                  ? <TopIdea key={index} post={post} index={index} pageLoading={pageLoading} />
                  : null
              ))}
              <Grid size={{ md: 12, xs: 12, sm: 12 }} sx={{ m: 0, pt: '12px !important' }}>
                <Box component="div" sx={{ m: 0, '& .MuiMasonry-root': { m: 0 } }}>
                  <Masonry
                    columns={{ xs: 1, sm: 1, md: 2 }}
                    spacing={{ xs: 2, sm: 2, md: 4 }}
                    defaultColumns={2}
                    defaultSpacing={2}
                    defaultHeight={1277}
                    sequential
                    sx={{ m: 0 }}
                  >
                    {_POSTS?.currentData()?.slice(1)?.map((post, index) => <Box key={index} component="div"><Idea post={post} index={index} /></Box>)}
                  </Masonry>
                </Box>
              </Grid>
              {posts && posts?.length > 0 ? null :
                <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                  <Box component="div" sx={{
                    mx: 'auto', textAlign: 'center', minHeight: '65vh', maxWidth: { md: '60%', sm: '100%', xs: '100%' },
                    display: 'flex', flexDirection: 'column', justifyContent: 'center'
                  }}>
                    <Typography variant="h6" className='post-title' sx={{ fontWeight: 600, mt: 2, }}>
                      Our analysts are diligently curating expert stock picks and market insights.
                    </Typography>
                    <Typography variant="p" className='post-title' sx={{ my: 3, }}>
                      In the meantime, explore our insightful blogs covering diverse financial topics,
                      from consumer credit trends and unemployment reports to
                      mega-cap stock performances year-to-date.
                    </Typography>
                    <Button href="/blogs" sx={{ textTransform: 'none', my: 3, mx: 'auto', width: { md: '60%', sm: '100%', xs: '100%' }, }} variant="contained">Explore our blogs</Button>
                  </Box>
                </Grid>}
              <Grid size={{ md: 12, xs: 12, sm: 12 }}>
                <Box component="div" sx={{ my: 7 }}>
                  {posts && posts?.length > ROWS_PER_PAGE ?
                    <Pagination
                      sx={{
                        '& .MuiPaginationItem-root.Mui-selected': {
                          border: '1px solid #174c86 !important',
                          color: '#174c86',
                          background: '#174c8629 !important'
                        },
                        '& .MuiPaginationItem-ellipsis': {
                          border: '0 !important'
                        },
                        '& .MuiPaginationItem-root': {
                          border: ' 1px solid rgba(0 0 0 / 0.23)',
                          fontWeight: 600
                        },
                        '& .MuiPagination-ul': {
                          justifyContent: 'center'
                        }
                      }}
                      count={count}
                      page={page}
                      onChange={handlePaginationChange}
                      variant="outlined"
                      shape="rounded"
                    /> : null}
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Typography variant="body2" component="div" color="rgba(0, 0, 0, 0.6)" sx={{ fontSize: '.75rem !important', textAlign: 'left', m: 2, fontStyle: 'italic' }} >
            {"Disclaimer: Conduct thorough research and seek guidance from a certified financial advisor prior to finalizing any investment choices."}
          </Typography>
        </Container>
      </Box>
    </>
  )
}

export async function getStaticProps() {
  const hero_data = (await getStockTabs("AAPL", "HERO")) || [];
  const { getStockTabs: hero } = hero_data || {};
  const { getBlogs: stock_ideas } = (await getStockIdeas()) || {}
  const meta_tags = (await getPageMetaTags('/stock-ideas', false)) || {}
  const { getMetaTags } = meta_tags || {}

  // Get slug and frontmatter from posts
  const posts = stock_ideas?.map((blog) => {
    const { data: frontmatter } = matter(blog?.content)

    return {
      slug: blog?.urlsuffix,
      frontmatter,
    }
  })

  return {
    props: {
      posts: posts?.sort(sortByDate) ?? [],
      hero: getHeroContent(hero, "stock-ideas") || {},
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.SIX_HOURS,
    // notFound: process.env.NODE_ENV !== 'production' ? false : true,
  }
}
